import {defaults} from "../defaults";
import {DATE_RANGE_EVENTS} from "../helpers/date-range-picker";

const periodSelectors = {
    quick: '.ng-period [data-period-time]',
    toggle: '#toggle-period',
    date: '.ng-period__date input',
};

/**
 * Periodevælgeren viser hurtigvalg og dato samtidig, men skabelonernes JS
 * læser stadig #toggle-period for at afgøre, hvilken af de to der gælder.
 * Kontakten sættes derfor af selve valget: hurtigvalg slår den fra, en
 * valgt dato slår den til. Body-klassen holdes i sync, som togglePeriod
 * ville have gjort.
 *
 * Sat uden at udløse change, så skabelonernes egne handlere står for
 * opdateringen — ellers ville siden hente data to gange pr. klik.
 */
function bindPeriodMode() {
    const setMode = (isCustom) => {
        $(periodSelectors.toggle).prop('checked', isCustom);
        $('body').toggleClass('custom-period', isCustom);
    };

    $(document).on('mousedown keydown', periodSelectors.quick, (event) => {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        setMode(false);
    });

    // Sættes allerede når vælgeren åbnes, ikke først ved apply: pluginet
    // kalder sit callback (som henter data) før apply-eventet, og så ville
    // den første datovalg blive læst som hurtigvalg. Harmløst at sætte
    // tidligt — skabelonerne kræver både kontakten OG en valgt dato.
    $(document).on(
        `${DATE_RANGE_EVENTS.open} ${DATE_RANGE_EVENTS.select}`,
        periodSelectors.date,
        () => setMode(true)
    );
}

export function bootPage(init = null) {
    $(function () {
        defaults.load();
        bindPeriodMode();

        if (typeof init === 'function') {
            init();
        }
    });
}
